var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainHeader',{staticClass:"unisale__header"}),_c('RouterView',{staticClass:"unisale__body"}),_c('MainFooter',{staticClass:"unisale__footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }